module.exports = __webpack_public_path__ + "img/kirinsushifrontview.bfab61ec.jpg";